import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-onboarding-watch-demo-video",
  "use": "icon-onboarding-watch-demo-video-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-onboarding-watch-demo-video\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 16h16V0H0z\" /><path d=\"M5 12.029V3.972a.5.5 0 0 1 .79-.407l5.64 4.03a.5.5 0 0 1 0 .813l-5.64 4.027A.5.5 0 0 1 5 12.03z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol